<div class="w-full h-full bg-[#FFFFFF]">
  <div class="w-full h-full flex flex-col">
    <div class="flex w-full h-[72px] relative z-10">
      <app-chatBIC-top-nav class="flex w-full justify-end"></app-chatBIC-top-nav>
    </div>
    <div class="flex-auto overflow-hidden relative p-6">
      <div class="flex flex-row h-full justify-center overflow-y-auto"
           [style.width]="(chatService.chatHistoryExpanded || chatService.allFilesExpanded) ? '75%' : '100%'"
           [ngClass]="!session.currentChat ? 'items-center' : ''">
        <div class="w-[864px]"
             [ngClass]="session.currentChat ? 'h-full' : 'h-auto'">
          <app-chatBIC-view [ngClass]="session.currentChat ? 'h-auto pt-6 pb-4' : 'h-auto'"
                            class="w-full"></app-chatBIC-view>
        </div>
      </div>

      <!-- Side panels positioned absolutely to stick to right edge -->
      @if (this.chatService.chatHistoryExpanded) {
        <app-all-chats-view
          class="absolute top-0 right-0 w-[25%] h-full pl-4 pr-6 pb-4 pt-6 bg-white z-0"></app-all-chats-view>
      }
      @if (this.chatService.allFilesExpanded) {
        <app-all-files-view
          class="absolute top-0 right-0 w-[25%] h-full pl-4 pr-6 pb-4 pt-6 bg-white z-0"></app-all-files-view>
      }
    </div>
    <div [style.width]="(chatService.chatHistoryExpanded || chatService.allFilesExpanded) ? '75%' : '100%'"
         class="flex flex-row w-full items-center justify-center px-6 pb-6">
      <div class="w-[864px]">
        @if (session.currentChat) {
          <app-message-view class="w-full"></app-message-view>
        }
      </div>
    </div>
  </div>
</div>
